import wrapIcon from './wrapIcon';

type IconProps = {
  onMouseColor?: string;
  onChangeColor?: string;
  width?: string;
  height?: string;
  isActive?: boolean;
};

function Icon({
  onMouseColor,
  onChangeColor,
  width,
  height,
  isActive,
  ...props
}: Readonly<IconProps>) {
  return (
    <svg
      width={width ?? '18'}
      height={height ?? '18'}
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 0.000156403L0 6.06233L7.5 12.1245V9.06233H13V3.06233L7.5 3.06233V0.000156403Z"
        fill={isActive ? onMouseColor : onChangeColor || 'black'}
      />
    </svg>
  );
}
const ArrowLeftIcon = wrapIcon(Icon);
export default ArrowLeftIcon;
